import {
	AdMob,
	BannerAdSize,
	BannerAdPosition,
	// BannerAdPluginEvents,
	// InterstitialAdPluginEvents,
} from "@capacitor-community/admob"

export async function initialize() {
	await AdMob.initialize({
		testingDevices: ["446EDD8C0634F72606DDE30E50E7A74B"],
		// initializeForTesting: true,
	})

	//mute all ads
	await AdMob.setApplicationMuted({ muted: true })
	await AdMob.setApplicationVolume({ volume: 0 })

	// const [trackingInfo, consentInfo] = await Promise.all([
	// 	AdMob.trackingAuthorizationStatus(),
	// 	AdMob
	// 		.requestConsentInfo
	// 		// {
	// 		// debugGeography: AdmobConsentDebugGeography.EEA,
	// 		// testDeviceIdentifiers: [""],
	// 		// }
	// 		(),
	// ])

	// if (trackingInfo.status === "notDetermined") {
	// 	/**
	// 	 * If you want to explain TrackingAuthorization before showing the iOS dialog,
	// 	 * you can show the modal here.
	// 	 * ex)
	// 	 * const modal = await this.modalCtrl.create({
	// 	 *   component: RequestTrackingPage,
	// 	 * });
	// 	 * await modal.present();
	// 	 * await modal.onDidDismiss();  // Wait for close modal
	// 	 **/

	// 	await AdMob.requestTrackingAuthorization()
	// }

	// const authorizationStatus = await AdMob.trackingAuthorizationStatus()
	// if (
	// 	authorizationStatus.status === "authorized" &&
	// 	consentInfo.isConsentFormAvailable &&
	// 	consentInfo.status === AdmobConsentStatus.REQUIRED
	// ) {
	// 	await AdMob.showConsentForm()
	// }
}

export async function banner() {
	await AdMob.removeBanner()

	// AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
	// 	// Subscribe Banner Event Listener
	// })

	// AdMob.addListener(BannerAdPluginEvents.SizeChanged, (size) => {
	// 	// Subscribe Change Banner Size
	// })

	const options = {
		adId: "ca-app-pub-6225091491024428/3762040247",
		// adId: "ca-app-pub-3940256099942544/9214589741",
		adSize: BannerAdSize.BANNER,
		position: BannerAdPosition.BOTTOM_CENTER,
		margin: 0,
		// isTesting: true,
		isTesting: false,
		// npa: true
	}

	try {
		const result = await AdMob.showBanner(options)
		// console.log(result)
	} catch (e) {
		console.log(e)
	}
}

export async function interstitial() {
	// AdMob.addListener(InterstitialAdPluginEvents.Loaded, (info) => {
	// 	// Subscribe prepared interstitial
	// })

	const options = {
		adId: "ca-app-pub-6225091491024428/5761517623",
		//adId: "ca-app-pub-3940256099942544/1033173712",
		// isTesting: true,
		isTesting: false,
		// npa: true
	}
	await AdMob.prepareInterstitial(options)
	await AdMob.showInterstitial()
}

export async function removeBanner() {
	await AdMob.removeBanner()
}
